import { render, staticRenderFns } from "./messageRecode.vue?vue&type=template&id=30020f89"
import script from "./messageRecode.vue?vue&type=script&lang=js"
export * from "./messageRecode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports